import { createContext } from "react";

import { type MachineGroup } from "@/schemas/machine-group";

export interface MachineGroupContextValue {
	changeMachineGroup: (machineGroup: MachineGroup | null | undefined) => void;
}

const initialValue: MachineGroupContextValue = {
	changeMachineGroup: () => {},
};

export const MachineGroupContext = createContext<MachineGroupContextValue>(initialValue);
